import {
  AnalyticsEventWithControlName,
  ACTIONS,
  activity,
  eventDetailVersion
} from '@uma/react-commons/dist/index';
import { screenPath, screenName } from 'src/utils/analytics';
import { URLS } from 'src/utils/urls';

export const ManageAdvancedSecurityOptionsHyperlinkClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
    activity,
    screenPath,
    screenName,
    controlName: 'ManageAdvancedSecurityOptionsLink',
    controlDetail: URLS.HpIdSecurity,
    version: eventDetailVersion
  };

export const MobileTwoFactorAuthHyperlinkClicked: AnalyticsEventWithControlName =
  {
    action: ACTIONS.CONTROL_HYPERLINK_CLICKED,
    activity,
    screenPath,
    screenName,
    controlName: 'MobileTwoFactorAuthLink',
    controlDetail: URLS.MobileTwoFactorAuth,
    version: eventDetailVersion
  };
